var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2213 11.4138C11.5065 11.1321 11.6667 10.7501 11.6667 10.3518C11.6667 9.95347 11.5065 9.57145 11.2213 9.28975L2.61548 0.791933C2.47515 0.64846 2.30729 0.534021 2.12169 0.455293C1.93609 0.376565 1.73647 0.335126 1.53448 0.333393C1.33248 0.331659 1.13217 0.369667 0.945208 0.445198C0.758251 0.520729 0.588398 0.63227 0.445563 0.773314C0.302728 0.914358 0.189769 1.08208 0.113279 1.26669C0.0367887 1.4513 -0.00170116 1.64911 5.41011e-05 1.84857C0.00180936 2.04803 0.0437747 2.24514 0.123502 2.42841C0.20323 2.61168 0.319123 2.77744 0.464419 2.91601L7.99466 10.3518L0.464419 17.7876C0.187309 18.0709 0.033974 18.4503 0.03744 18.8442C0.0409061 19.2381 0.200896 19.6148 0.48295 19.8934C0.765004 20.1719 1.14656 20.3299 1.54543 20.3333C1.9443 20.3367 2.32857 20.1853 2.61548 19.9117L11.2213 11.4138Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.7dd6056c0ce71918ca35dcce77070da7.svg";
export { ForwardRef as ReactComponent };